export default {
  endpoint: 'https://favor8api.safe-iplay.com/'
};
